import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, getDocs, doc, deleteDoc } from "firebase/firestore";
import { db, auth } from "./firebase";
import { FaHeart } from "react-icons/fa";
import "./SavedProperties.css";

const SavedProperties = () => {
  const [savedList, setSavedList] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fetch saved properties
  useEffect(() => {
    const fetchSavedProperties = async () => {
      try {
        const user = auth.currentUser;

        if (!user || !user.uid) {
          console.warn("No user logged in.");
          setSavedList([]);
          setLoading(false);
          return;
        }

        const savedRef = collection(db, "users", user.uid, "saved-properties");
        const snap = await getDocs(savedRef);

        const properties = snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));

        setSavedList(properties);
      } catch (error) {
        console.error("Error fetching saved properties:", error);
        setSavedList([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSavedProperties();
  }, []);

  // Remove from saved list
  const handleUnsave = async (listingId) => {
    try {
      const user = auth.currentUser;
      if (!user || !user.uid) {
        alert("Please log in first.");
        return;
      }

      if (!listingId) {
        console.error("Missing listing ID for unsave action");
        return;
      }

      const docRef = doc(db, "users", user.uid, "saved-properties", listingId);
      await deleteDoc(docRef);

      setSavedList((prev) => prev.filter((item) => item.id !== listingId));
    } catch (error) {
      console.error("Error unsaving property:", error);
      alert("Could not unsave property. Try again.");
    }
  };

  if (loading) {
    return <div className="loading">Loading saved properties...</div>;
  }

  if (savedList.length === 0) {
    return <div className="no-saved">No saved properties yet.</div>;
  }

  return (
    <div className="saved-properties-container">
      <h2>Saved Properties</h2>
      <div className="saved-grid">
        {savedList.map((property) => (
          <div
            key={property.id}
            className="saved-card"
          onClick={() => {
  if (property.type === "rent") navigate(`/rent/${property.id}`);
  else navigate(`/pg/${property.id}`);
}}
          >
            <div className="card-image-wrapper">
              <img
                src={property.thumbnailURL || "/placeholder.jpg"}
                alt={property.pgName || property.title || "Saved property"}
                className="saved-thumbnail"
              />
              <button
                className="unsave-btn"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent navigation
                  handleUnsave(property.id);
                }}
              >
                <FaHeart size={18} color="red" />
              </button>
            </div>
            <div className="card-details">
              <h3>{property.pgName || property.title || "Unnamed Property"}</h3>
              <p>₹{property.rent || "N/A"}</p>
              <p>
                {property.roomType || "Room"} • {property.occupancy || "N/A"}
              </p>
              <p>{property.exactLocation || property.city || "Unknown Location"}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedProperties;
